export default __webpack_public_path__ + "static/RootSans-5Regular-e1f0023e2d87e261f9a7677b63d31945.woff2";